import { Tracking } from '@skyscanner/strevda-tracking';
import { ERROR_BOUNDARY_PREFIX_QUARK } from '@skyscanner-internal/landing-pages-shared-constants/constants';
import { logWarn } from 'saddlebag-logger';

import type { FeatureContainerItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/FeatureContainerProps';

const logAdvertReceived = (advert: FeatureContainerItem) => {
  try {
    Tracking.trackAdReceived(advert.componentProps.advert.trackingData);
  } catch (error) {
    logWarn({
      error: String(error),
      component: `${ERROR_BOUNDARY_PREFIX_QUARK}LogAdvertsReceived`,
      message: 'Error while attempting to log ad received tracking',
    });
  }
};

export default logAdvertReceived;
